import React, { useState } from "react";
import "./EventDeniedModal.css";

const EventDeniedModal = ({
  isOpen,
  onClose,
  deviceId,
  deviceName,
  timestamp,
  actionType,
  actionDetails,
}) => {
  const [theme] = useState(
    document.body.classList.contains("dark") ? "dark" : "light"
  );

  if (!isOpen) return null;

  const formattedTimestamp = new Date(timestamp).toLocaleString();

  return (
    <>
      <div className="event-denied-modal-overlay" />
      <div className={`event-denied-modal ${theme}`}>
        <h2>⚠️ Event Denied</h2>
        <h3>Action Blocked Due to Lockdown</h3>
        <p className="centered">
          An action was attempted but denied because the device is in lockdown
          mode:
        </p>

        <table className="device-details">
          <tbody>
            <tr>
              <td>Device Name:</td>
              <td>{deviceName || "Unknown"}</td>
            </tr>
            <tr>
              <td>Device ID:</td>
              <td>{deviceId}</td>
            </tr>
            <tr>
              <td>Action Attempted:</td>
              <td>{actionType || "Unknown"}</td>
            </tr>
            {actionDetails && (
              <tr>
                <td>Details:</td>
                <td>{actionDetails}</td>
              </tr>
            )}
            <tr>
              <td>Time of Attempt:</td>
              <td>{formattedTimestamp}</td>
            </tr>
          </tbody>
        </table>

        <p className="centered">
          The device is currently in lockdown mode. Release lockdown to allow
          this action.
        </p>
        <button onClick={onClose}>Acknowledge</button>
      </div>
    </>
  );
};

export default EventDeniedModal;
